import { Box, Drawer, Typography, IconButton } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import Input from 'components/Common/Input';
import { useForm } from 'react-hook-form';
import Button from 'components/Common/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { useCreateOrUpdateChunk, useGetChunk, useGetDataSet } from 'apis/business/setting/knowledgeBase/hook';
import ChunkFormSkeleton from './ChunkFormSkeleton';

export default function ChunkForm() {
  const navigate = useNavigate();
  const { chunkId } = useParams();

  const { mutateAsync: handleChunk, isPending } = useCreateOrUpdateChunk();
  const { data: dataset, isLoading: isDataSetLoading } = useGetDataSet();
  const { data: chunk, isLoading } = useGetChunk();

  const { handleSubmit, control } = useForm({
    values: ['qa', 'website'].includes(dataset?.datasource_type ?? '')
      ? {
          chunk: { question: chunk?.question, answer: chunk?.answer }
        }
      : {
          chunk: { text: chunk?.text }
        }
  });

  const onSubmit = async (data: any) => {
    await handleChunk(data);
  };

  if (isLoading || isDataSetLoading) {
    return <ChunkFormSkeleton />;
  }

  return (
    <Drawer
      anchor='right'
      open={true}
      onClose={() => navigate(-1)}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 200, md: 400, lg: 700 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Fixed Header */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}
      >
        <Typography variant='h6'>{chunkId ? 'Edit' : 'Add'} Chunk</Typography>
        <IconButton onClick={() => navigate(-1)} size='small'>
          <IoClose size={24} />
        </IconButton>
      </Box>

      {/* Form with Fixed Footer */}
      <Box
        component='form'
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Scrollable Content */}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3
          }}
        >
          {dataset?.datasource_type === 'website' ? (
            <>
              <Box mb={4}>
                <Input
                  name='chunk.question'
                  label='Question'
                  control={control}
                  minRows={5}
                  fullWidth
                  multiline
                  required
                />
              </Box>
              <Box>
                <Input name='chunk.answer' label='Answer' control={control} minRows={5} fullWidth multiline required />
              </Box>
            </>
          ) : (
            <Input name='chunk.text' label='Chunk' control={control} minRows={5} fullWidth multiline required />
          )}
        </Box>

        {/* Fixed Footer */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderTop: '1px solid #DEDEDE',
            display: 'flex',
            justifyContent: 'end',
            gap: 2,
            flexShrink: 0
          }}
        >
          <Button
            color='secondary'
            variant='outlined'
            sx={{ border: '1px solid #F3F3F3' }}
            onClick={() => navigate(-1)}
          >
            Cancel
          </Button>
          <Button type='submit' variant='contained' isPending={isPending}>
            {chunkId ? 'Update' : 'Create'}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
